// Import the centralized brand configuration
import brandConfig from '@/config/brands.json';

// Brand configuration for dynamic domain-based branding
export enum BrandMode {
  Kirana360 = 'kirana360',
  Munshiji = 'munshiji',
  // Add more modes as needed
}

export interface BrandConfig {
  mode: BrandMode;
  name: string;
  supportEmail: string;
  website: string;
  publicUrl: string; // URL to use for public links (like WhatsApp sharing)
  tagline: string;
  logo: {
    useCustomLogo: boolean;
    component?: string; // Component name for custom logos
  };
  // Mobile app configuration
  mobile: {
    packageName: string;
    bundleId: string;
  };
  // Favicon configuration
  favicon: {
    basePath: string;
    title: string;
  };
}

// Convert JSON config to typed configuration
export const BRAND_CONFIGS: Record<string, BrandConfig> = brandConfig.brands as Record<string, BrandConfig>;

// Optionally, export a default brand for unknown domains
export const DEFAULT_BRAND: BrandConfig = BRAND_CONFIGS[brandConfig.defaultBrand]!; 